import gql from 'graphql-tag'

export const getPolicyById = gql`
  query($policyId: Int!) {
    getPolicyById(
      policyId: $policyId
    ) {
      id
      policyName
      status
      type
      effectiveDate
      expirationDate
      originalInceptionDate
      bindDate
      brokerFee
      agencyFee
      carrierPolicyFee
      inspectionFee
      taxesFee
      stampingFee
      premium
      policyNumber
      term
      closed
      nonRenew
      payerType
      shouldAutoCancel
      cancelDate
      shouldAutoBor
      borDate
      createdAt
      updatedAt
      productCommissionOverride
      caseId
      additionalInfoStr
      installmentPlan
      billingType
      isPremiumPayOff
      isPaidToCarrier
      isCommissionPayOff
      totalProjectedPremium
      totalProjectedCommission
      book {
        id
        name
      }
      labels {
        id
        content
        color
      }
      account {
        id
        name
        mailingAddressCity
        mailingAddressCountry
        mailingAddressPostalCode
        mailingAddressState
        mailingAddressStreet
        phone
        otherPhone
        source {
          id
          name
        }
      }
      primaryContact {
        id
        name
      }
      source {
        id
        name
      }
      carrier {
        id
        name
        hoursOfOperation
        policyTypes
        amBestRating
        notes
        website
        username
        password
        producerCode
        directAppointment
        primaryAddressState
        primaryAddressCity
        primaryAddressZipCode
        primaryAddressStreet1
        primaryAddressStreet2
        email
        phone
        fax
        policyDocumentsDelivery
        downloads
        endorsementDocumentDelivery
      }
      carrierProduct {
        id
        name
        notes
        toBeReviewed
        naicCode
        lineOfBusinessCode
        downloads
        policyDocumentsDelivery
        endorsementDocumentDelivery
        quoteVia
        agencyBill
        bindIssueVia
      }
      generalAgent {
        id
        name
      }
      recordType {
        id
        name
      }
      insuranceQuote {
        id
        name
      }
      insureds {
        id
        name
        relationShip
        dateOfBirth
      }
      vehicles {
        id
        name
        vin
        year
        make
        loan
        model
        notes
        vehicleCoverage
        ownership
        mileage
        useage
        roadsideTowing
        rentalCarCoverage
        createdAt
        updatedAt
        quote {
          id
          name
        }
        policy {
          id
          policyName
        }
        lienHolder {
          id
          name
        }
      }
      properties {
        id
        address
        city
        state
      }
      acordForms {
        id
        notes
        name
        size
        version
        url
        lockedUrl
        createdAt
        acordFormId
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      attachments {
        id
        type
        name
        size
        createdAt
        updatedAt
      }
      payments {
        id
        amount
        receivedDate
        status
        paymentMethod
        notes
        createdAt
        updatedAt
        createdBy {
          id
          userType
        }
      }
      commissions {
        id
        amount
        receivedDate
        status
        paymentMethod
        notes
        createdAt
        updatedAt
        createdBy {
          id
          userType
        }
        statementId
      }
      inheritPolicies {
        fromPolicy {
          id
          policyName
          type
        }
        toPolicy {
          id
          policyName
          type
        }
      }
      openedCases {
        id
        inquiryName
        type
        createdAt
        updatedAt
        lastModifiedBy {
          id
          username
        }
        createdBy {
          id
          username
        }
      }
      writingAgents {
        id
        username
      }
    }
  }
`

export const getPolicies = gql`
  query($paging: PagingQuery, $order: PoliciesOrder, $filter: PoliciesFilter!) {
    getPolicies(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      policies {
        id
        policyName
        status
        effectiveDate
        expirationDate
        originalInceptionDate
        bindDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        payerType
        type
        closed
        nonRenew
        createdAt
        updatedAt
        productCommissionOverride
        additionalInfoStr
        billingType
        isPremiumPayOff
        isCommissionPayOff
        billingType
        totalProjectedCommission
        totalProjectedPremium
        totalPremiumReceived
        totalCommissionReceived
        cancelDate
        book {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
        source {
          id
          name
        }
        recordType {
          id
          name
        }
        account {
          id
          name
          producers {
            id
            username
          }
        }
        insuranceQuote {
          id
          name
        }
        primaryContact {
          id
          name
        }
        payments {
          id
          amount
          receivedDate
          status
          notes
          createdAt
          updatedAt
        }
        commissions {
          id
          amount
          receivedDate
          status
          notes
          createdAt
          updatedAt
        }
        generalAgent {
          id
          name
        }
        inheritPolicies {
          fromPolicy {
            id
            policyName
            type
          }
        }
        writingAgents {
          id
          username
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getCandidatePolicies = gql`
  query($paging: PagingQuery, $filter: PoliciesFilter!) {
    getPolicies(
      filter: $filter,
      paging: $paging
    ) {
      policies {
        id
        policyName
        type
        status
        effectiveDate
        expirationDate
        policyNumber
        account {
          id
          name
        }
        recordType {
          id
          name
        }
      }
    }
  }
`

export const newPolicy = gql`
  mutation($policyInput: NewPolicyInput!) {
    newPolicy(
      policyInput: $policyInput
    ) {
      id
    }
  }
`

export const deletePolicyById = gql`
  mutation($policyId: Int!) {
    deletePolicyById(
      policyId: $policyId
    )
  }
`

export const editPolicy = gql`
  mutation($policyInput: EditPolicyInput!, $policyId: Int!) {
    editPolicy(
      policyInput: $policyInput,
      policyId: $policyId
    ) {
      id
    }
  }
`

export const newPolicyPayment = gql`
  mutation($paymentInput: PaymentInput!) {
    newPolicyPayment(input: $paymentInput) {
      id
    }
  }
`

export const editPolicyPayment = gql`
  mutation($paymentInput: PaymentInput!, $paymentId: Int!) {
    editPolicyPayment(input: $paymentInput, paymentId: $paymentId) {
      id
    }
  }
`

export const deletePolicyPayment = gql`
  mutation($paymentId: Int!) {
    deletePolicyPayment(paymentId: $paymentId)
  }
`

export const newPolicyCommission = gql`
  mutation($commissionInput: CommissionInput!) {
    newPolicyCommission(input: $commissionInput) {
      id
    }
  }
`

export const editPolicyCommission = gql`
  mutation($commissionInput: CommissionInput!, $commissionId: Int!) {
    editPolicyCommission(input: $commissionInput, commissionId: $commissionId) {
      id
    }
  }
`

export const deletePolicyCommission = gql`
  mutation($commissionId: Int!) {
    deletePolicyCommission(commissionId: $commissionId)
  }
`

export const switchPremiumPayOff = gql`
  mutation($status: Boolean!, $policyId: Int!) {
    switchPremiumPayOff(status: $status, policyId: $policyId) {
      id
    }
  }
`

export const switchCommissionPayOff = gql`
  mutation($status: Boolean!, $policyId: Int!) {
    switchCommissionPayOff(status: $status, policyId: $policyId) {
      id
    }
  }
`

export const switchPaidToCarrier = gql`
  mutation($status: Boolean!, $policyId: Int!) {
    switchPaidToCarrier(status: $status, policyId: $policyId) {
      id
    }
  }
`

export const updatePolicyLabels = gql`
  mutation($labelIds: [Int!]!, $policyId: Int!) {
    updatePolicyLabels(
      labelIds: $labelIds,
      policyId: $policyId
    ) {
      id
    }
  }
`

export const deleteAcordForm = gql`
  mutation($acordId: Int!) {
    deleteAcordForm(
      acordId: $acordId
    )
  }
`

export const renameAcordForm = gql`
  mutation($acordId: Int!, $newName: String!) {
    renameAcordForm(
      acordId: $acordId,
      newName: $newName
    ) {
      id
    }
  }
`

export const updatePolicyNonRenew = gql`
  mutation($policyId: Int!, $nonRenew: Boolean!) {
    updatePolicyNonRenew(
      policyId: $policyId,
      nonRenew: $nonRenew
    ) {
      id
    }
  }
`

export const updatePolicyCancelDate = gql`
  mutation($policyId: Int!, $cancelDate: String!, $autoCancel: Boolean!) {
    updatePolicyCancelDate(
      policyId: $policyId,
      cancelDate: $cancelDate,
      autoCancel: $autoCancel
    ) {
      id
    }
  }
`

export const updatePolicyBorDate = gql`
  mutation($policyId: Int!, $borDate: String!, $autoBor: Boolean!) {
    updatePolicyBorDate(
      policyId: $policyId,
      borDate: $borDate,
      autoBor: $autoBor
    ) {
      id
    }
  }
`

export const getGlobalSearchPolicies = gql`
  query($query: String!, $order: PoliciesOrder!, $paging: PagingQuery!) {
    globalSearchPolicies(
      query: $query,
      order: $order,
      paging: $paging
    ) {
      policies {
        id
        policyName
        policyNumber
        additionalInfoStr
      }
    }
  }
`

export const getAllGlobalSearchPolicies = gql`
  query($query: String!, $order: PoliciesOrder!, $paging: PagingQuery!) {
    globalSearchPolicies(
      query: $query,
      order: $order,
      paging: $paging
    ) {
      policies {
        id
        policyName
        policyNumber
        status
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        premium
        effectiveDate
        expirationDate
        source {
          id
          name
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getPolicyHistories = gql`
  query($policyId: Int!) {
    getPolicyHistories(
      policyId: $policyId,
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`
